import { isCanlan } from './customer-name'

/* Felipe Nunes: Updated Sat, 17 Jan 2026 3:34 AM ( CET ) */
// If it fails (like if the previously set hardcoded token is expired)
// try setting the hardcoded token again (hopefully a new one)
// {
//   "access_token": "v2.local.Gskz7r2AW2N9R0ndV9NvXPyyBAxk7cslJ1eAdUAI6INH1WlNy4DK_7rhJ9nojgXTfUG9UCySaVQr0EWsTPVdbfzaMLuCyotHcokFfQqcbUQrHpti6ux4_9DOoTSu-9JZIk3VqQHezvTu6UjwQbpQmBICVQYDEe_ceu63lgmgiglcu6BxHBBXxrxBt2v9Qh3Fey4-dTUTcGeEUyzIDC7n1m5pUU0nE832NFc_6rUmWQjaW1sNZi9qHWKMEiYu5K7o2mgm9zzGBDXCOkbxV_YOVOHy6ZIMVgY06cY-Qnb68rAzvxI7OEcEpVr46spFegTey9xJSXqaKJIE-MBJGRs3LNfeT27JaTLTiA",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-01-24T02:33:57.815796Z",
//   "user": {
//     "id": "TAcc3KT6ikeaqhvL",
//     "email": "michael+planeticeservice@sportninja.com",
//     "created_at": "2022-08-29T23:14:34+00:00",
//     "updated_at": "2026-01-17T01:58:17+00:00",
//     "validated_at": "2022-08-29T23:14:42+00:00"
//   }
// }
const planetIceToken =
  'v2.local.Gskz7r2AW2N9R0ndV9NvXPyyBAxk7cslJ1eAdUAI6INH1WlNy4DK_7rhJ9nojgXTfUG9UCySaVQr0EWsTPVdbfzaMLuCyotHcokFfQqcbUQrHpti6ux4_9DOoTSu-9JZIk3VqQHezvTu6UjwQbpQmBICVQYDEe_ceu63lgmgiglcu6BxHBBXxrxBt2v9Qh3Fey4-dTUTcGeEUyzIDC7n1m5pUU0nE832NFc_6rUmWQjaW1sNZi9qHWKMEiYu5K7o2mgm9zzGBDXCOkbxV_YOVOHy6ZIMVgY06cY-Qnb68rAzvxI7OEcEpVr46spFegTey9xJSXqaKJIE-MBJGRs3LNfeT27JaTLTiA'

// {
//   "access_token": "v2.local.HTn8w7smnDV5UHZEUU7gNMThiA862J89dVLkxqT-mnK-I6XkBlbX401Dji9kcGnUjkhWKhXU35dtZZli6J28SXhRnOVERhDU3f27QM4BucxIi93miuRFAs00d35yp946qbhSOxS7j0xKOW0ANi7sb75cJE6Hvfxip6hJEFnX6rlPs95GP-_Gs68jEJmsER9vN_Xg0CE3W4ZHmFZBOtcMNn2z_tmlBTTRrEZfpEK7sxNTDa_Gn5rk5qc6513g-IWIUPd9ABZ57oYyOxTej0A6rWzC7CO3NhsjlqV32mouPPWX1kjPXnF73iGgRbb9gf_r3JGQHrcsQfpmm8bGTOm4y5VAVHaa",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-01-24T02:35:50.052869Z",
//   "user": {
//     "id": "oP37ysYCd57bFlkj",
//     "email": "michael+carhaservice@sportninja.com",
//     "created_at": "2022-05-27T18:35:59+00:00",
//     "updated_at": "2026-01-17T02:35:43+00:00",
//     "validated_at": "2022-05-27T18:35:59+00:00"
//   }
// }
const carhaToken =
  'v2.local.HTn8w7smnDV5UHZEUU7gNMThiA862J89dVLkxqT-mnK-I6XkBlbX401Dji9kcGnUjkhWKhXU35dtZZli6J28SXhRnOVERhDU3f27QM4BucxIi93miuRFAs00d35yp946qbhSOxS7j0xKOW0ANi7sb75cJE6Hvfxip6hJEFnX6rlPs95GP-_Gs68jEJmsER9vN_Xg0CE3W4ZHmFZBOtcMNn2z_tmlBTTRrEZfpEK7sxNTDa_Gn5rk5qc6513g-IWIUPd9ABZ57oYyOxTej0A6rWzC7CO3NhsjlqV32mouPPWX1kjPXnF73iGgRbb9gf_r3JGQHrcsQfpmm8bGTOm4y5VAVHaa'

// {
//   "access_token": "v2.local.8GSK6qy4v8SU1rYqB9dsID952F_DweJe5lLdz5gohYvtGhfFh7bX25eWbVPuvM5uKuX9wrxgnTrpX9ymnza6ClBvvs15S2B1ZxICFemwSOxWFCkKett0n85hZROAI9tjfhUujv-i1-YnmSHpqrkxlO1kxWW1hi2OgV2fCc6FMsAnBaeydUz49vtlr7nFGpi0p4ikNFRd_NGTfBglOp7sCYXFIPYysfFgKQeLzzl-3lk0nV0zdx2Vr3NAuhNPlUVdB792JKOeDeduz5h4ykWvDEHqSc-PUNKrDZbTFJjVwz35oEXYYxHPyKGoenOS6gj_AQxMfiTEDbTjFPPgAHHrVi_Gwtk",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-01-24T02:37:07.448138Z",
//   "user": {
//     "id": "jJkc8qSsffa24rAE",
//     "email": "michael+canlanservice@sportninja.com",
//     "created_at": "2022-05-30T20:39:26+00:00",
//     "updated_at": "2023-05-19T19:59:44+00:00",
//     "validated_at": "2022-05-30T20:39:26+00:00"
//   }
// }
const canlanToken =
  'v2.local.8GSK6qy4v8SU1rYqB9dsID952F_DweJe5lLdz5gohYvtGhfFh7bX25eWbVPuvM5uKuX9wrxgnTrpX9ymnza6ClBvvs15S2B1ZxICFemwSOxWFCkKett0n85hZROAI9tjfhUujv-i1-YnmSHpqrkxlO1kxWW1hi2OgV2fCc6FMsAnBaeydUz49vtlr7nFGpi0p4ikNFRd_NGTfBglOp7sCYXFIPYysfFgKQeLzzl-3lk0nV0zdx2Vr3NAuhNPlUVdB792JKOeDeduz5h4ykWvDEHqSc-PUNKrDZbTFJjVwz35oEXYYxHPyKGoenOS6gj_AQxMfiTEDbTjFPPgAHHrVi_Gwtk'

export const getIframeToken = () => {
  const parentUrl =
    window.location !== window.parent.location
      ? window?.document?.referrer
      : window?.document?.location?.href

  let isPlanetIce = false
  if (parentUrl && parentUrl.includes('pacificadulthockey.com')) {
    isPlanetIce = true
  }
  return isCanlan ? canlanToken : isPlanetIce ? planetIceToken : carhaToken
}
